export default __webpack_public_path__ + "static/locally-sourced-28b3133158bfac527eb4663c49446f2e.png";